import {BrowserRouter, Route, Routes} from "react-router";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import MemorialPage from "./pages/MemorialPage";
import RegisterConfirmPage from "./pages/RegisterConfirmPage";
import HomePage from "./pages/HomePage";
import ResetPasswordPage from "./pages/ResetPasswordPage.tsx";
import ResetPasswordConfirmPage from "./pages/ResetPasswordConfirmPage.tsx";
import ChangePasswordPage from "./pages/ChangePasswordPage.tsx";
import Layout from "@memaro/components/Layout.tsx";
import TrackPageViews from "./components/TrackPageViews.tsx";
import {useAuth} from "./lib/auth.ts";
import AcceptTermsPage from "./pages/AcceptTermsPage.tsx";

function App() {
    const {state, userAttributes} = useAuth()
    return (
        <Layout>
            {state == "authenticated" && !userAttributes?.acceptedTerms ? (
                <AcceptTermsPage/>
            ) : (
                <BrowserRouter>
                    <TrackPageViews/>
                    <Routes>
                        <Route index element={<HomePage/>}/>
                        <Route path="login" element={<LoginPage/>}/>
                        <Route path="register" element={<RegisterPage/>}/>
                        <Route path="register/confirm" element={<RegisterConfirmPage/>}/>
                        <Route path="reset-password" element={<ResetPasswordPage/>}/>
                        <Route path="reset-password/confirm" element={<ResetPasswordConfirmPage/>}/>
                        <Route path="change-password" element={<ChangePasswordPage/>}/>
                        <Route path=":profileID" element={<MemorialPage/>}/>
                    </Routes>
                </BrowserRouter>
            )}
        </Layout>
    )
}

export default App
